module.exports = __webpack_public_path__ + "img/Group 10.ec706c6b.svg";